export const tr = {
    banner: 'Reklam',
    'campaign-group': 'Kampanya/Grup',
    'campaign-type': 'Kampanya türü',
    price: 'Reklamdaki fiyat',
    status: 'Durum',
    type: 'Tür'
};
